/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81a7dedc0a0c6bb6970207479c2a88dd>>
 * @codegenCommand yarn build tokens
 */
export default `
html[data-color-mode="light"][data-theme~="light:light"], [data-subtree-theme][data-color-mode="light"][data-theme~="light:light"],
html[data-color-mode="dark"][data-theme~="dark:light"], [data-subtree-theme][data-color-mode="dark"][data-theme~="dark:light"] {
  color-scheme: light;
  --ds-text: #292A2E;
  --ds-text-accent-lime: #4C6B1F;
  --ds-text-accent-lime-bolder: #37471F;
  --ds-text-accent-red: #AE2E24;
  --ds-text-accent-red-bolder: #5D1F1A;
  --ds-text-accent-orange: #9E4C00;
  --ds-text-accent-orange-bolder: #693200;
  --ds-text-accent-yellow: #7F5F01;
  --ds-text-accent-yellow-bolder: #533F04;
  --ds-text-accent-green: #216E4E;
  --ds-text-accent-green-bolder: #164B35;
  --ds-text-accent-teal: #206A83;
  --ds-text-accent-teal-bolder: #164555;
  --ds-text-accent-blue: #1558BC;
  --ds-text-accent-blue-bolder: #123263;
  --ds-text-accent-purple: #803FA5;
  --ds-text-accent-purple-bolder: #48245D;
  --ds-text-accent-magenta: #943D73;
  --ds-text-accent-magenta-bolder: #50253F;
  --ds-text-accent-gray: #505258;
  --ds-text-accent-gray-bolder: #1E1F21;
  --ds-text-disabled: #080F214A;
  --ds-text-inverse: #FFFFFF;
  --ds-text-selected: #1868DB;
  --ds-text-brand: #1868DB;
  --ds-text-danger: #AE2E24;
  --ds-text-danger-bolder: #5D1F1A;
  --ds-text-warning: #9E4C00;
  --ds-text-warning-inverse: #292A2E;
  --ds-text-warning-bolder: #693200;
  --ds-text-success: #4C6B1F;
  --ds-text-success-bolder: #37471F;
  --ds-text-discovery: #803FA5;
  --ds-text-discovery-bolder: #48245D;
  --ds-text-information: #1558BC;
  --ds-text-information-bolder: #123263;
  --ds-text-subtlest: #6B6E76;
  --ds-text-subtle: #505258;
  --ds-link: #1868DB;
  --ds-link-pressed: #1558BC;
  --ds-link-visited: #803FA5;
  --ds-link-visited-pressed: #48245D;
  --ds-icon: #292A2E;
  --ds-icon-accent-lime: #6A9A23;
  --ds-icon-accent-red: #C9372C;
  --ds-icon-accent-orange: #E06C00;
  --ds-icon-accent-yellow: #B38600;
  --ds-icon-accent-green: #22A06B;
  --ds-icon-accent-teal: #2898BD;
  --ds-icon-accent-blue: #357DE8;
  --ds-icon-accent-purple: #AF59E1;
  --ds-icon-accent-magenta: #CD519D;
  --ds-icon-accent-gray: #7D818A;
  --ds-icon-disabled: #080F214A;
  --ds-icon-inverse: #FFFFFF;
  --ds-icon-selected: #1868DB;
  --ds-icon-brand: #1868DB;
  --ds-icon-danger: #C9372C;
  --ds-icon-warning: #E06C00;
  --ds-icon-warning-inverse: #292A2E;
  --ds-icon-success: #6A9A23;
  --ds-icon-discovery: #AF59E1;
  --ds-icon-information: #357DE8;
  --ds-icon-subtlest: #6B6E76;
  --ds-icon-subtle: #505258;
  --ds-border: #0B120E24;
  --ds-border-accent-lime: #6A9A23;
  --ds-border-accent-red: #E2483D;
  --ds-border-accent-orange: #E06C00;
  --ds-border-accent-yellow: #B38600;
  --ds-border-accent-green: #22A06B;
  --ds-border-accent-teal: #2898BD;
  --ds-border-accent-blue: #357DE8;
  --ds-border-accent-purple: #AF59E1;
  --ds-border-accent-magenta: #CD519D;
  --ds-border-accent-gray: #7D818A;
  --ds-border-disabled: #0515240F;
  --ds-border-focused: #4688EC;
  --ds-border-input: #8C8F97;
  --ds-border-inverse: #FFFFFF;
  --ds-border-selected: #1868DB;
  --ds-border-brand: #1868DB;
  --ds-border-danger: #E2483D;
  --ds-border-warning: #E06C00;
  --ds-border-success: #6A9A23;
  --ds-border-discovery: #AF59E1;
  --ds-border-information: #357DE8;
  --ds-border-bold: #7D818A;
  --ds-background-accent-lime-subtlest: #EFFFD6;
  --ds-background-accent-lime-subtlest-hovered: #D3F1A7;
  --ds-background-accent-lime-subtlest-pressed: #BDE97C;
  --ds-background-accent-lime-subtler: #D3F1A7;
  --ds-background-accent-lime-subtler-hovered: #BDE97C;
  --ds-background-accent-lime-subtler-pressed: #B3DF72;
  --ds-background-accent-lime-subtle: #94C748;
  --ds-background-accent-lime-subtle-hovered: #B3DF72;
  --ds-background-accent-lime-subtle-pressed: #BDE97C;
  --ds-background-accent-lime-bolder: #5B7F24;
  --ds-background-accent-lime-bolder-hovered: #4C6B1F;
  --ds-background-accent-lime-bolder-pressed: #3F5224;
  --ds-background-accent-red-subtlest: #FFECEB;
  --ds-background-accent-red-subtlest-hovered: #FFD5D2;
  --ds-background-accent-red-subtlest-pressed: #FFB8B2;
  --ds-background-accent-red-subtler: #FFD5D2;
  --ds-background-accent-red-subtler-hovered: #FFB8B2;
  --ds-background-accent-red-subtler-pressed: #FD9891;
  --ds-background-accent-red-subtle: #F87168;
  --ds-background-accent-red-subtle-hovered: #FD9891;
  --ds-background-accent-red-subtle-pressed: #FFB8B2;
  --ds-background-accent-red-bolder: #C9372C;
  --ds-background-accent-red-bolder-hovered: #AE2E24;
  --ds-background-accent-red-bolder-pressed: #872821;
  --ds-background-accent-orange-subtlest: #FFF5DB;
  --ds-background-accent-orange-subtlest-hovered: #FCE4A6;
  --ds-background-accent-orange-subtlest-pressed: #FBD779;
  --ds-background-accent-orange-subtler: #FCE4A6;
  --ds-background-accent-orange-subtler-hovered: #FBD779;
  --ds-background-accent-orange-subtler-pressed: #FBC828;
  --ds-background-accent-orange-subtle: #FCA700;
  --ds-background-accent-orange-subtle-hovered: #FBC828;
  --ds-background-accent-orange-subtle-pressed: #FBD779;
  --ds-background-accent-orange-bolder: #BD5B00;
  --ds-background-accent-orange-bolder-hovered: #9E4C00;
  --ds-background-accent-orange-bolder-pressed: #7A3B00;
  --ds-background-accent-yellow-subtlest: #FEF7C8;
  --ds-background-accent-yellow-subtlest-hovered: #F5E989;
  --ds-background-accent-yellow-subtlest-pressed: #EFDD4E;
  --ds-background-accent-yellow-subtler: #F5E989;
  --ds-background-accent-yellow-subtler-hovered: #EFDD4E;
  --ds-background-accent-yellow-subtler-pressed: #EED12B;
  --ds-background-accent-yellow-subtle: #EED12B;
  --ds-background-accent-yellow-subtle-hovered: #DDB30E;
  --ds-background-accent-yellow-subtle-pressed: #EFDD4E;
  --ds-background-accent-yellow-bolder: #946F00;
  --ds-background-accent-yellow-bolder-hovered: #7F5F01;
  --ds-background-accent-yellow-bolder-pressed: #614A05;
  --ds-background-accent-green-subtlest: #DCFFF1;
  --ds-background-accent-green-subtlest-hovered: #BAF3DB;
  --ds-background-accent-green-subtlest-pressed: #97EDC9;
  --ds-background-accent-green-subtler: #BAF3DB;
  --ds-background-accent-green-subtler-hovered: #97EDC9;
  --ds-background-accent-green-subtler-pressed: #7EE2B8;
  --ds-background-accent-green-subtle: #4BCE97;
  --ds-background-accent-green-subtle-hovered: #7EE2B8;
  --ds-background-accent-green-subtle-pressed: #97EDC9;
  --ds-background-accent-green-bolder: #1F845A;
  --ds-background-accent-green-bolder-hovered: #216E4E;
  --ds-background-accent-green-bolder-pressed: #19573D;
  --ds-background-accent-teal-subtlest: #E7F9FF;
  --ds-background-accent-teal-subtlest-hovered: #C6EDFB;
  --ds-background-accent-teal-subtlest-pressed: #B1E4F7;
  --ds-background-accent-teal-subtler: #C6EDFB;
  --ds-background-accent-teal-subtler-hovered: #B1E4F7;
  --ds-background-accent-teal-subtler-pressed: #9DD9EE;
  --ds-background-accent-teal-subtle: #6CC3E0;
  --ds-background-accent-teal-subtle-hovered: #9DD9EE;
  --ds-background-accent-teal-subtle-pressed: #B1E4F7;
  --ds-background-accent-teal-bolder: #227D9B;
  --ds-background-accent-teal-bolder-hovered: #206A83;
  --ds-background-accent-teal-bolder-pressed: #1A5265;
  --ds-background-accent-blue-subtlest: #E9F2FE;
  --ds-background-accent-blue-subtlest-hovered: #CFE1FD;
  --ds-background-accent-blue-subtlest-pressed: #ADCBFB;
  --ds-background-accent-blue-subtler: #CFE1FD;
  --ds-background-accent-blue-subtler-hovered: #ADCBFB;
  --ds-background-accent-blue-subtler-pressed: #8FB8F6;
  --ds-background-accent-blue-subtle: #669DF1;
  --ds-background-accent-blue-subtle-hovered: #8FB8F6;
  --ds-background-accent-blue-subtle-pressed: #ADCBFB;
  --ds-background-accent-blue-bolder: #1868DB;
  --ds-background-accent-blue-bolder-hovered: #1558BC;
  --ds-background-accent-blue-bolder-pressed: #144794;
  --ds-background-accent-purple-subtlest: #F8EEFE;
  --ds-background-accent-purple-subtlest-hovered: #EED7FC;
  --ds-background-accent-purple-subtlest-pressed: #E3BDFA;
  --ds-background-accent-purple-subtler: #EED7FC;
  --ds-background-accent-purple-subtler-hovered: #E3BDFA;
  --ds-background-accent-purple-subtler-pressed: #D8A0F7;
  --ds-background-accent-purple-subtle: #C97CF4;
  --ds-background-accent-purple-subtle-hovered: #D8A0F7;
  --ds-background-accent-purple-subtle-pressed: #E3BDFA;
  --ds-background-accent-purple-bolder: #964AC0;
  --ds-background-accent-purple-bolder-hovered: #803FA5;
  --ds-background-accent-purple-bolder-pressed: #673286;
  --ds-background-accent-magenta-subtlest: #FFECF8;
  --ds-background-accent-magenta-subtlest-hovered: #FDD0EC;
  --ds-background-accent-magenta-subtlest-pressed: #FCB6E1;
  --ds-background-accent-magenta-subtler: #FDD0EC;
  --ds-background-accent-magenta-subtler-hovered: #FCB6E1;
  --ds-background-accent-magenta-subtler-pressed: #F797D2;
  --ds-background-accent-magenta-subtle: #E774BB;
  --ds-background-accent-magenta-subtle-hovered: #F797D2;
  --ds-background-accent-magenta-subtle-pressed: #FCB6E1;
  --ds-background-accent-magenta-bolder: #AE4787;
  --ds-background-accent-magenta-bolder-hovered: #943D73;
  --ds-background-accent-magenta-bolder-pressed: #77325B;
  --ds-background-accent-gray-subtlest: #F0F1F2;
  --ds-background-accent-gray-subtlest-hovered: #DDDEE1;
  --ds-background-accent-gray-subtlest-pressed: #B7B9BE;
  --ds-background-accent-gray-subtler: #DDDEE1;
  --ds-background-accent-gray-subtler-hovered: #B7B9BE;
  --ds-background-accent-gray-subtler-pressed: #8C8F97;
  --ds-background-accent-gray-subtle: #8C8F97;
  --ds-background-accent-gray-subtle-hovered: #B7B9BE;
  --ds-background-accent-gray-subtle-pressed: #DDDEE1;
  --ds-background-accent-gray-bolder: #6B6E76;
  --ds-background-accent-gray-bolder-hovered: #505258;
  --ds-background-accent-gray-bolder-pressed: #3B3D42;
  --ds-background-disabled: #17171708;
  --ds-background-input: #FFFFFF;
  --ds-background-input-hovered: #F8F8F8;
  --ds-background-input-pressed: #FFFFFF;
  --ds-background-inverse-subtle: #00000029;
  --ds-background-inverse-subtle-hovered: #0000003D;
  --ds-background-inverse-subtle-pressed: #00000052;
  --ds-background-neutral: #0515240F;
  --ds-background-neutral-hovered: #0B120E24;
  --ds-background-neutral-pressed: #080F214A;
  --ds-background-neutral-subtle: #00000000;
  --ds-background-neutral-subtle-hovered: #0515240F;
  --ds-background-neutral-subtle-pressed: #0B120E24;
  --ds-background-neutral-bold: #292A2E;
  --ds-background-neutral-bold-hovered: #3B3D42;
  --ds-background-neutral-bold-pressed: #505258;
  --ds-background-selected: #E9F2FE;
  --ds-background-selected-hovered: #CFE1FD;
  --ds-background-selected-pressed: #8FB8F6;
  --ds-background-selected-bold: #1868DB;
  --ds-background-selected-bold-hovered: #1558BC;
  --ds-background-selected-bold-pressed: #123263;
  --ds-background-brand-subtlest: #E9F2FE;
  --ds-background-brand-subtlest-hovered: #CFE1FD;
  --ds-background-brand-subtlest-pressed: #ADCBFB;
  --ds-background-brand-bold: #1868DB;
  --ds-background-brand-bold-hovered: #1558BC;
  --ds-background-brand-bold-pressed: #144794;
  --ds-background-brand-boldest: #1C2B42;
  --ds-background-brand-boldest-hovered: #123263;
  --ds-background-brand-boldest-pressed: #144794;
  --ds-background-danger: #FFECEB;
  --ds-background-danger-hovered: #FFD5D2;
  --ds-background-danger-pressed: #FFB8B2;
  --ds-background-danger-subtler: #FFD5D2;
  --ds-background-danger-subtler-hovered: #FFB8B2;
  --ds-background-danger-subtler-pressed: #FD9891;
  --ds-background-danger-bold: #C9372C;
  --ds-background-danger-bold-hovered: #AE2E24;
  --ds-background-danger-bold-pressed: #872821;
  --ds-background-warning: #FFF5DB;
  --ds-background-warning-hovered: #FCE4A6;
  --ds-background-warning-pressed: #FBD779;
  --ds-background-warning-subtler: #FCE4A6;
  --ds-background-warning-subtler-hovered: #FBD779;
  --ds-background-warning-subtler-pressed: #FBC828;
  --ds-background-warning-bold: #FBC828;
  --ds-background-warning-bold-hovered: #FCA700;
  --ds-background-warning-bold-pressed: #F68909;
  --ds-background-success: #EFFFD6;
  --ds-background-success-hovered: #D3F1A7;
  --ds-background-success-pressed: #BDE97C;
  --ds-background-success-subtler: #D3F1A7;
  --ds-background-success-subtler-hovered: #BDE97C;
  --ds-background-success-subtler-pressed: #B3DF72;
  --ds-background-success-bold: #5B7F24;
  --ds-background-success-bold-hovered: #4C6B1F;
  --ds-background-success-bold-pressed: #3F5224;
  --ds-background-discovery: #F8EEFE;
  --ds-background-discovery-hovered: #EED7FC;
  --ds-background-discovery-pressed: #E3BDFA;
  --ds-background-discovery-subtler: #EED7FC;
  --ds-background-discovery-subtler-hovered: #E3BDFA;
  --ds-background-discovery-subtler-pressed: #D8A0F7;
  --ds-background-discovery-bold: #964AC0;
  --ds-background-discovery-bold-hovered: #803FA5;
  --ds-background-discovery-bold-pressed: #673286;
  --ds-background-information: #E9F2FE;
  --ds-background-information-hovered: #CFE1FD;
  --ds-background-information-pressed: #ADCBFB;
  --ds-background-information-subtler: #CFE1FD;
  --ds-background-information-subtler-hovered: #ADCBFB;
  --ds-background-information-subtler-pressed: #8FB8F6;
  --ds-background-information-bold: #1868DB;
  --ds-background-information-bold-hovered: #1558BC;
  --ds-background-information-bold-pressed: #144794;
  --ds-blanket: #050C1F75;
  --ds-blanket-selected: #388BFF14;
  --ds-blanket-danger: #EF5C4814;
  --ds-interaction-hovered: #00000029;
  --ds-interaction-pressed: #00000052;
  --ds-skeleton: #0515240F;
  --ds-skeleton-subtle: #17171708;
  --ds-chart-categorical-1: #357DE8;
  --ds-chart-categorical-1-hovered: #1868DB;
  --ds-chart-categorical-2: #82B536;
  --ds-chart-categorical-2-hovered: #6A9A23;
  --ds-chart-categorical-3: #BF63F3;
  --ds-chart-categorical-3-hovered: #AF59E1;
  --ds-chart-categorical-4: #F68909;
  --ds-chart-categorical-4-hovered: #E06C00;
  --ds-chart-categorical-5: #1558BC;
  --ds-chart-categorical-5-hovered: #123263;
  --ds-chart-categorical-6: #964AC0;
  --ds-chart-categorical-6-hovered: #803FA5;
  --ds-chart-categorical-7: #42B2D7;
  --ds-chart-categorical-7-hovered: #2898BD;
  --ds-chart-categorical-8: #BD5B00;
  --ds-chart-categorical-8-hovered: #7A3B00;
  --ds-chart-lime-bold: #6A9A23;
  --ds-chart-lime-bold-hovered: #5B7F24;
  --ds-chart-lime-bolder: #5B7F24;
  --ds-chart-lime-bolder-hovered: #4C6B1F;
  --ds-chart-lime-boldest: #4C6B1F;
  --ds-chart-lime-boldest-hovered: #37471F;
  --ds-chart-neutral: #8C8F97;
  --ds-chart-neutral-hovered: #7D818A;
  --ds-chart-red-bold: #F15B50;
  --ds-chart-red-bold-hovered: #E2483D;
  --ds-chart-red-bolder: #E2483D;
  --ds-chart-red-bolder-hovered: #C9372C;
  --ds-chart-red-boldest: #AE2E24;
  --ds-chart-red-boldest-hovered: #5D1F1A;
  --ds-chart-orange-bold: #E06C00;
  --ds-chart-orange-bold-hovered: #BD5B00;
  --ds-chart-orange-bolder: #BD5B00;
  --ds-chart-orange-bolder-hovered: #9E4C00;
  --ds-chart-orange-boldest: #7A3B00;
  --ds-chart-orange-boldest-hovered: #693200;
  --ds-chart-yellow-bold: #B38600;
  --ds-chart-yellow-bold-hovered: #946F00;
  --ds-chart-yellow-bolder: #946F00;
  --ds-chart-yellow-bolder-hovered: #7F5F01;
  --ds-chart-yellow-boldest: #7F5F01;
  --ds-chart-yellow-boldest-hovered: #533F04;
  --ds-chart-green-bold: #22A06B;
  --ds-chart-green-bold-hovered: #1F845A;
  --ds-chart-green-bolder: #1F845A;
  --ds-chart-green-bolder-hovered: #216E4E;
  --ds-chart-green-boldest: #216E4E;
  --ds-chart-green-boldest-hovered: #164B35;
  --ds-chart-teal-bold: #2898BD;
  --ds-chart-teal-bold-hovered: #227D9B;
  --ds-chart-teal-bolder: #227D9B;
  --ds-chart-teal-bolder-hovered: #206A83;
  --ds-chart-teal-boldest: #206A83;
  --ds-chart-teal-boldest-hovered: #164555;
  --ds-chart-blue-bold: #4688EC;
  --ds-chart-blue-bold-hovered: #357DE8;
  --ds-chart-blue-bolder: #357DE8;
  --ds-chart-blue-bolder-hovered: #1868DB;
  --ds-chart-blue-boldest: #1558BC;
  --ds-chart-blue-boldest-hovered: #123263;
  --ds-chart-purple-bold: #BF63F3;
  --ds-chart-purple-bold-hovered: #AF59E1;
  --ds-chart-purple-bolder: #AF59E1;
  --ds-chart-purple-bolder-hovered: #964AC0;
  --ds-chart-purple-boldest: #803FA5;
  --ds-chart-purple-boldest-hovered: #48245D;
  --ds-chart-magenta-bold: #DA62AC;
  --ds-chart-magenta-bold-hovered: #CD519D;
  --ds-chart-magenta-bolder: #CD519D;
  --ds-chart-magenta-bolder-hovered: #AE4787;
  --ds-chart-magenta-boldest: #943D73;
  --ds-chart-magenta-boldest-hovered: #50253F;
  --ds-chart-gray-bold: #8C8F97;
  --ds-chart-gray-bold-hovered: #7D818A;
  --ds-chart-gray-bolder: #7D818A;
  --ds-chart-gray-bolder-hovered: #6B6E76;
  --ds-chart-gray-boldest: #505258;
  --ds-chart-gray-boldest-hovered: #3B3D42;
  --ds-chart-brand: #357DE8;
  --ds-chart-brand-hovered: #1868DB;
  --ds-chart-danger: #E2483D;
  --ds-chart-danger-hovered: #C9372C;
  --ds-chart-danger-bold: #872821;
  --ds-chart-danger-bold-hovered: #5D1F1A;
  --ds-chart-warning: #F68909;
  --ds-chart-warning-hovered: #E06C00;
  --ds-chart-warning-bold: #BD5B00;
  --ds-chart-warning-bold-hovered: #9E4C00;
  --ds-chart-success: #82B536;
  --ds-chart-success-hovered: #6A9A23;
  --ds-chart-success-bold: #5B7F24;
  --ds-chart-success-bold-hovered: #4C6B1F;
  --ds-chart-discovery: #BF63F3;
  --ds-chart-discovery-hovered: #AF59E1;
  --ds-chart-discovery-bold: #803FA5;
  --ds-chart-discovery-bold-hovered: #964AC0;
  --ds-chart-information: #357DE8;
  --ds-chart-information-hovered: #1868DB;
  --ds-chart-information-bold: #1558BC;
  --ds-chart-information-bold-hovered: #123263;
  --ds-surface: #FFFFFF;
  --ds-surface-hovered: #F0F1F2;
  --ds-surface-pressed: #DDDEE1;
  --ds-surface-overlay: #FFFFFF;
  --ds-surface-overlay-hovered: #F0F1F2;
  --ds-surface-overlay-pressed: #DDDEE1;
  --ds-surface-raised: #FFFFFF;
  --ds-surface-raised-hovered: #F0F1F2;
  --ds-surface-raised-pressed: #DDDEE1;
  --ds-surface-sunken: #F8F8F8;
  --ds-shadow-overflow: 0px 0px 8px #1E1F2129, 0px 0px 1px #1E1F211F;
  --ds-shadow-overflow-perimeter: #1E1F211f;
  --ds-shadow-overflow-spread: #1E1F2129;
  --ds-shadow-overlay: 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214F;
  --ds-shadow-raised: 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214F;
  --ds-opacity-disabled: 0.4;
  --ds-opacity-loading: 0.2;
  --ds-UNSAFE-transparent: transparent;
  --ds-elevation-surface-current: #FFFFFF;
}
`;
